let dirPath = 'static/games/page019_game3';
let dirAudio = 'games/page019_game3/audio/';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  bruteForce: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: { shuffle: true },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'left',
        idItem: 'con4',
        items: [{ idGroup: 'right', idItem: 'con4', correct: [{ idGroup: 'left', idItem: 'con4' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con3',
        items: [{ idGroup: 'right', idItem: 'con3', correct: [{ idGroup: 'left', idItem: 'con3' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con2',
        items: [{ idGroup: 'right', idItem: 'con2', correct: [{ idGroup: 'left', idItem: 'con2' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con1',
        items: [{ idGroup: 'right', idItem: 'con1', correct: [{ idGroup: 'left', idItem: 'con1' }] }],
      },
    ],
  },
  layout: {
    itemsConfig: {
      background: {
        text: {
          lineWidth: 300,
          font: 'Myriad Pro',
          size: '30px',
          textBaseline: 'middle',
          textAlign: 'center',
        },
      },
    },
    otherProperty: {
      lines: {
        good: {
          hideLine: true,
        },
        connect: {
          color: '#e9ed9b',
          hideLine: true,
        },
        select: {
          color: '#e9ed9b',
          hideLine: true,
        },
      },
      points: {
        pointMouse: {
          color: 'rgba(0,0,0,0.3)',
          rad: 0,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          image: {
            src: dirPath + '/img/point.png',
          },
          color: 'transparent',
          positions: { rad: 15 },
        },
      },
    },
    groups: [
      {
        idGroup: 'left',
        positions: { autoFit: true, type: 'absolute', pos: { x: 130, y: 0 } },
        itemsConfig: {
          positions: { pos: { width: 335, height: 159 }, margin: { left: 50 }, columns: 4 },
          // background: { color: ['#67c28d'] },
        },
        otherProperty: {
          points: {
            itemsConfig: { positions: { rad: 0 }, registrationPoint: { setTo: 'bottom' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'bottom' }, offset: { y: -21 } } }],
          },
        },
        items: [
          { id: 'con1', background: { image: { src: dirPath + '/img/10.png' } }, otherProperty: { audio: 'a01' } },
          { id: 'con2', background: { image: { src: dirPath + '/img/11.png' } }, otherProperty: { audio: 'a02' } },
          { id: 'con3', background: { image: { src: dirPath + '/img/12.png' } }, otherProperty: { audio: 'a03' } },
          { id: 'con4', background: { image: { src: dirPath + '/img/13.png' } }, otherProperty: { audio: 'a04' } },
        ],
      },
      {
        idGroup: 'right',
        itemsConfig: {
          positions: { pos: { width: 300, height: 160 } },
          background: { color: ['transparent'] },
        },
        otherProperty: {
          lines: {
            good: {
              hideLine: true,
            },
            connect: {
              color: '#e9ed9b',
              hideLine: true,
            },
            select: {
              color: '#e9ed9b',
              hideLine: true,
            },
          },
          points: {
            itemsConfig: { positions: { rad: 0 }, registrationPoint: { setTo: 'top' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'top' }, offset: { y: 21 } } }],
          },
        },
        positions: {
          type: 'absolute',
          autoFit: true,
        },
        items: [
          {
            id: 'con1',
            positions: { pos: { width: 199, height: 377 }, margin: { left: 90, top: 458 } },
            background: { image: { src: dirPath + '/img/00.png', pos: { y: 62 } } },
          },
          {
            id: 'con2',
            positions: { pos: { width: 652, height: 249 }, margin: { left: 90, top: 458 } },
            background: { image: { src: dirPath + '/img/01.png', pos: { y: 62 } } },
          },
          {
            id: 'con3',
            positions: { pos: { width: 372, height: 120 }, margin: { left: 90, top: 458 } },
            background: { image: { src: dirPath + '/img/02.png', pos: { y: 62 } } },
          },
          {
            id: 'con4',
            positions: { pos: { width: 153, height: 187 }, margin: { left: 90, top: 458 } },
            background: { image: { src: dirPath + '/img/03.png', pos: { y: 62 } } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'connect',
  mainImage: {
    imagePath: dirPath + '/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + 'z19c3-4.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 178,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + 'z19c3-3.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
        // src: {
        //   iconOn: '',
        //   iconOff: ''
        // },
      },
      pos: {
        y: 178,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + 'z19c3-2.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 178,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + 'z19c3-1.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 178,
        x: 70,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
  ],
  realHeight: 840,
  realWidth: 1800,
  configGame: configGame,
};

export default dataConfig;
